<template>
  <div class="home">
    <CountriesFinder />
  </div>
</template>

<script>
// @ is an alias to /src
import CountriesFinder from '@/components/countries/CountriesFinder.vue';

export default {
  // name: 'Home',
  components: {
    CountriesFinder,
  },
};
</script>
